<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>党费系统</el-breadcrumb-item>
        <el-breadcrumb-item>缴费管理</el-breadcrumb-item>
        <el-breadcrumb-item>缴费月份</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form inline :model="listParams" label-width="100px">
        <el-form-item label="缴费月份：">
          <el-date-picker
            v-model="listParams.timeInterval"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleRefresh">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column width="80" align="center" label="序号">
          <template slot-scope="scope">
            <span
              v-text="
                (pager.pageIndex > 1
                  ? (pager.pageIndex - 1) * pager.pageSize
                  : 0) +
                  scope.$index +
                  1
              "
            >
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="status" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: green;"
              >开放</span
            >
            <span v-if="scope.row.status === 2" style="color: red;">关闭</span>
          </template>
        </el-table-column>

        <el-table-column prop="paymentMonth" align="center" label="缴费月份">
        </el-table-column>

        <el-table-column prop="endDate" align="center" label="缴费截止日期">
        </el-table-column>

        <el-table-column prop="paymentMonth" align="center" label="缴费人数">
          <template slot-scope="scope">
            <span>{{ scope.row.paymentMember }}/{{ scope.row.allMember }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="payment" align="center" label="缴费金额">
          <template slot-scope="scope">
            <span style="color: red;">{{
              scope.row.payment | formatToFixed2("元")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="linkToDetailPage(scope.row.id)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      listParams: {
        timeInterval: []
      },
      pager: {
        total: 0,
        pageIndex: 1,
        pageSize: 15
      },
      tableData: [],
      tableLoading: false
    };
  },
  mounted() {
    this.handleRefresh();
  },
  methods: {
    handleRefresh() {
      this.pager.pageIndex = 1;
      this.loadTableData();
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, this.pager);
      if (bodyParams.timeInterval && bodyParams.timeInterval.length == 2) {
        bodyParams.startDate = bodyParams.timeInterval[0].valueOf();
        bodyParams.endDate = bodyParams.timeInterval[1].valueOf();
      }
      delete bodyParams.timeInterval;
      delete bodyParams.total;
      Vue.ajaxGet(
        this,
        global.apiUrl + "/partyFee/getPaymentMonthList",
        bodyParams,
        "tableLoading"
      ).then(res => {
        this.tableData = res.dataList;
        this.pager.total = res.total;
      });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 跳转至详情页
     * @param id
     */
    linkToDetailPage(id) {
      this.$router.push({
        name: "paymentMonthDetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
